import React from 'react';
import { CardGrid } from '@openedx/paragon';
import DiscoverCard from './DiscoverCard';

const DiscoverCardsGrid = ({ courses }) => (
  <section className="discover-cards-grid">
    <CardGrid columnSizes={{ sm: 12, md: 6, lg: 4 }}>
      {courses.map((course) => (
        <DiscoverCard key={course.id} {...course} />
      ))}
    </CardGrid>
  </section>
);

export default DiscoverCardsGrid;
